<h2>core</h2>
<p>{{core.ctrlName}}</p>